module.exports = new __parcel__URL__("kitten1.604e710c.png").toString();